var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.725 2.725C1.992 3.457 1.6 4.66 1.6 6.6v4.8c0 1.941.392 3.144 1.125 3.876C3.457 16.01 4.66 16.4 6.6 16.4h4.8c1.941 0 3.144-.391 3.876-1.124.733-.732 1.124-1.935 1.124-3.876v-4a.6.6 0 1 1 1.2 0v4c0 2.06-.408 3.657-1.475 4.725C15.057 17.192 13.46 17.6 11.4 17.6H6.6c-2.059 0-3.656-.408-4.724-1.475C.81 15.057.4 13.46.4 11.4V6.6c0-2.059.409-3.656 1.476-4.724C2.944.81 4.541.4 6.6.4h4a.6.6 0 1 1 0 1.2h-4c-1.94 0-3.143.392-3.875 1.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.37.446a.6.6 0 0 1 .654.13l6.4 6.4A.6.6 0 0 1 17 8h-3.2c-1.233 0-2.246-.197-2.924-.875C10.198 6.447 10 5.434 10 4.2V1a.6.6 0 0 1 .37-.554Zm.83 2.003V4.2c0 1.167.202 1.754.524 2.076.322.322.91.524 2.076.524h1.752L11.2 2.45Z",
    fill: "currentColor"
  })));
};
export default SvgDocument;